(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('HomeController', HomeController);
		 
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Ventahoyrealtime', '$interval'];

    function HomeController ($scope, Principal, LoginService, $state, Ventahoyrealtime, $interval) {
        var vm = this;
		var refreshTimer;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.ventahoyrealtimes = [];

        function loadAll() {
            Ventahoyrealtime.query(function(result) {
                vm.ventahoyrealtimes = result;
                vm.searchQuery = null;
            });
		}

        loadAll();

		//$window.location.reload();
		
		refreshTimer= $interval(loadAll, 300000);
		//if(refreshTimer)
		//	$interval.flush(60000*5);
			
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
		
		$scope.stop = function() {
			if(refreshTimer)
				$interval.cancel(refreshTimer);
		};
			
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

		$scope.$on('$destroy', function () {
			$scope.stop();
        }); 
		
    }
})();
